<template>
    <b-container fluid class="animated fadeIn">
        <h1>Incluir / Alterar Parâmetros do Sistema</h1>
        <b-card>
            <p class="titulo-secao">Dados Gerais</p>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Dias Fechados no Início do Mês: *" label-for="diasFechadoFimMes" class="text-label">
                        <b-form-input 
                            name="diasFechadoFimMes"
                            v-model="parametros.diasFechadoFimMes" 
                            type="number" 
                            maxlength="8"
                            v-validate="{ required: true, max: 8 }" />
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Limite de Registros para Consultar o Valor no DAE: *" label-for="qtdSimultaneaConsultaDae" class="text-label">
                        <b-form-input 
                            name="qtdSimultaneaConsultaDae"
                            v-model="parametros.qtdSimultaneaConsultaDae" 
                            type="number"
                            v-validate="{ required: true , max: 8 }" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="E-mail do Procurador Geral da PGE: *" label-for="emailCoordenador" class="text-label">
                        <b-form-input 
                            name="emailCoordenador"
                            v-model="parametros.emailCoordenador" 
                            type="text" 
                            maxlength="120"
                            v-validate="'required|email'" />
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Procurador Geral da PGE: *" label-for="procuradorGeral" class="text-label">
                        <multiselect
                            name="procuradorGeral"
                            v-model="parametros.procuradorGeral"
                            :show-labels="false"
                            :options="dados.procuradores"
                            :multiple="false"
                            :close-on-select="true"
                            :clear-on-select="true"
                            :preserve-search="false"
                            placeholder="Selecione"
                            track-by="codProcurador"
                            label="nome"
                            v-validate="{ required: true }"
                        >
                        </multiselect>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Telefone do órgão responsável pelo ajuizamento:" label-for="telefoneorgao" class="text-label">
                        <the-mask 
                            name="telefoneorgao"
                            class="form-control"
                            v-model="parametros.telefoneorgao"
                            type="text"
                            :mask="['(##) #####-####', '(##) ####-####']" 
                            :masked="true" />
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Quantidade de threads executadas em paralelo na funcionalidade de obtenção das CDAS: *" label-for="qtdThreadsObterCdas" class="text-label">
                        <b-form-input 
                            name="qtdThreadsObterCdas"
                            v-model="parametros.qtdThreadsObterCdas" 
                            type="number"
                            v-validate="{ required: true , max: 8 }" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Nome do órgão responsável: " label-for="nomeOrgao" class="text-label">
                        <b-form-input 
                            name="nomeOrgao"
                            v-model="parametros.nomeOrgao" 
                            type="text" 
                            maxlength="80"
                            v-validate="{ max: 80 }"  />
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="CNPJ do órgão responsável:" label-for="cnpjOrgao" class="text-label">
                        <the-mask 
                            name="cnpjOrgao"
                            class="form-control"
                            v-model="parametros.cnpjOrgao"
                            type="text"
                            mask="##.###.###/####-##" 
                            :masked="true" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Endereço do órgão responsável:" label-for="enderecoOrgao" class="text-label">
                        <b-form-input 
                            name="enderecoOrgao"
                            v-model="parametros.enderecoOrgao" 
                            type="text" 
                            maxlength="200"
                            v-validate="{ max: 200 }" />
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Município do órgão:" label-for="municipio" class="text-label">
                        <multiselect
                            name="municipio"
                            v-model="parametros.municipioOrgao"
                            :show-labels="false"
                            :options="dados.municipios"
                            :multiple="false"
                            :close-on-select="true"
                            :clear-on-select="true"
                            :preserve-search="false"
                            placeholder="Selecione"
                            track-by="codMunicipio"
                            label="nome"
                        >
                        </multiselect>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Quantidade máxima para obter CDAs com PDF por requisição:" label-for="qtdObterCdaPdf" class="text-label">
                        <b-form-input 
                            name="qtdObterCdaPdf"
                            v-model="parametros.qtdObterCdaPdf" 
                            type="number" 
                            maxlength="8"
                            v-validate="{ max: 8 }" />
                    </b-form-group>
                </b-col>
            </b-row>
            <p class="titulo-secao">Ajuizamento</p>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Tempo de execução Enviar Processo para o TJ: *" label-for="tempoExecucacaoEnviarProcessoTJ" class="text-label">
                        <b-form-input 
                            name="tempoExecucacaoEnviarProcessoTJ"
                            v-model="parametros.tempoExecucacaoEnviarProcessoTJ" 
                            type="number" 
                            maxlength="8"
                            v-validate="{ required: true, max: 8 }" />
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Tempo de Execução de Inclusão no SPJ:" label-for="tempoExecucacaoIncluirSPJ" class="text-label">
                        <b-form-input 
                            name="tempoExecucacaoIncluirSPJ"
                            v-model="parametros.tempoExecucacaoIncluirSPJ" 
                            type="number"
                            v-validate="{ max: 8 }" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Quantidade de Threads de Envio de Processos para o TJ: *" label-for="qtdThreadsEnviarProcessoTJ" class="text-label">
                        <b-form-input 
                            name="qtdThreadsEnviarProcessoTJ"
                            v-model="parametros.qtdThreadsEnviarProcessoTJ" 
                            type="number" 
                            maxlength="8"
                            v-validate="{ required: true, max: 8 }" />
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Tempo de Atualização da Página: *" label-for="tempoAtualizacaoPagina" class="text-label">
                        <b-form-input 
                            name="tempoAtualizacaoPagina"
                            v-model="parametros.tempoAtualizacaoPagina" 
                            type="number"
                            v-validate="{ required: true , max: 8 }" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Quantidade de cdas por processo:" label-for="qtdCdaProcesso" class="text-label">
                        <b-form-input 
                            name="qtdCdaProcesso"
                            v-model="parametros.qtdCdaProcesso" 
                            type="number" 
                            maxlength="8"
                            v-validate="{ max: 8 }" />
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Prazo em dias para retorno do Enviado para Ajuizamento: *" label-for="prazoRetornoDiaSEPA" class="text-label">
                        <b-form-input 
                            name="prazoRetornoDiaSEPA"
                            v-model="parametros.prazoRetornoDiaSEPA" 
                            type="number"
                            v-validate="{ required: true , max: 8 }" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="8" lg="8" xl="8">
                    <b-form-group label="Quantidade de dias para retorno de CDAS que ainda não foi distribuído o CNPJ no TJ: *" label-for="qtdeRetornoCDAnaoDistribuidas" class="text-label">
                        <b-form-input 
                            name="qtdeRetornoCDAnaoDistribuidas"
                            v-model="parametros.qtdeRetornoCDAnaoDistribuidas" 
                            type="number" 
                            maxlength="8"
                            v-validate="{ required: true, max: 8 }" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="8" lg="8" xl="8">
                    <b-form-group label="Quantidade de gias agrupadas para a geração de um processo de ajuizamento: *" label-for="qtdGiaAjuizamento" class="text-label">
                        <b-form-input 
                            name="qtdGiaAjuizamento"
                            v-model="parametros.qtdGiaAjuizamento" 
                            type="number" 
                            maxlength="8"
                            v-validate="{ required: true, max: 8 }" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="8" lg="8" xl="8">
                    <b-form-group label="Quantidade de threads que poderão ser executadas simultaneamente na montagem de processos: *" label-for="qtdThreadsMontagemProcesso" class="text-label">
                        <b-form-input 
                            name="qtdThreadsMontagemProcesso"
                            v-model="parametros.qtdThreadsMontagemProcesso" 
                            type="number" 
                            maxlength="8"
                            v-validate="{ required: true, max: 8 }" />
                    </b-form-group>
                </b-col>
            </b-row>
            <p class="titulo-secao">Protesto</p>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="E-mail responsável CRA: *" label-for="emailCra" class="text-label">
                        <b-form-input 
                            name="emailCra"
                            v-model="parametros.emailCra" 
                            type="text" 
                            maxlength="250"
                            v-validate="'required|email'" />
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Quantidade threads seleção para protesto: *" label-for="qtdThreadSelecaoProtesto" class="text-label">
                        <b-form-input 
                            name="qtdThreadSelecaoProtesto"
                            v-model="parametros.qtdThreadSelecaoProtesto" 
                            type="number"
                            v-validate="{ required: true , max: 8 }" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Data limite para envio do protesto: *" label-for="dataLimiteProtesto" class="text-label">
                        <b-form-input 
                            name="dataLimiteProtesto"
                            v-model="parametros.dataLimiteProtesto" 
                            type="number" 
                            maxlength="8"
                            v-validate="{ required: true, max: 8 }" />
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Quantidade para referência quebra arquivo xml enviado à CRA: *" label-for="qtdeReferenciaQuebraXML" class="text-label">
                        <b-form-input 
                            name="qtdeReferenciaQuebraXML"
                            v-model="parametros.qtdeReferenciaQuebraXML" 
                            type="number"
                            v-validate="{ required: true , max: 8 }"/>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Quantidade de CDAs por lote(máximo permitido): *" label-for="qtdCdaLoteCra" class="text-label">
                        <b-form-input 
                            name="qtdCdaLoteCra"
                            v-model="parametros.qtdCdaLoteCra" 
                            type="number" 
                            maxlength="8"
                            v-validate="{ required: true,  max: 8 }" />
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Quantidade de dias de exibição da carta de anuência no pós protesto: *" label-for="qtdDiasExibicaoAnuencia" class="text-label">
                        <b-form-input 
                            name="qtdDiasExibicaoAnuencia"
                            v-model="parametros.qtdDiasExibicaoAnuencia" 
                            type="number"
                            v-validate="{ required: true, max: 8 }" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="8" lg="8" xl="8">
                    <b-form-group label="Quantidade de threads que serão executadas ao verificar pagamento / parcelamento no DAE: *" label-for="qtdThreadsPagamentoParcelamentoDae" class="text-label">
                        <b-form-input 
                            name="qtdThreadsPagamentoParcelamentoDae"
                            v-model="parametros.qtdThreadsPagamentoParcelamentoDae" 
                            type="number" 
                            maxlength="8"
                            v-validate="{ required: true, max: 8 }" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="8" lg="8" xl="8">
                    <b-form-group label="Quantidade de threads para execução no verificar pagamento: *" label-for="qtdThreadsConsultaPgto" class="text-label">
                        <b-form-input 
                            name="qtdThreadsConsultaPgto"
                            v-model="parametros.qtdThreadsConsultaPgto" 
                            type="number" 
                            maxlength="8"
                            v-validate="{ required: true, max: 8 }" />
                    </b-form-group>
                </b-col>
            </b-row>
            <p class="titulo-secao">Valor/Tipo de Crédito</p>
            <b-row>
                <b-col xs="12" sm="12" md="5" lg="5" xl="5">
                    <b-form-group label="Tipo de Crédito: *" label-for="tipoCredito" class="text-label">
                        <multiselect
                            name="tipoCredito"
                            v-model="valorTipoCredito.tipoCredito"
                            :show-labels="false"
                            :options="dados.tiposCredito"
                            :multiple="false"
                            :close-on-select="true"
                            :clear-on-select="true"
                            :preserve-search="false"
                            placeholder="Selecione"
                            track-by="id"
                            label="nome"
                        >
                        </multiselect>
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="7" lg="7" xl="7" >
                    <b-form-group label="Valor(R$): *" label-for="valor" class="text-label">
                        <b-form inline >
                            <money
                                class="form-control"
                                v-model="valorTipoCredito.valorAjuizamento"
                                v-bind="money"></money>
                            <b-form-checkbox v-if="edicaoTipoCredito" class="mx-auto" switch v-model="valorTipoCredito.indAtivo">{{ valorTipoCredito.indAtivo ? 'Ativo' : 'Inativo'}}</b-form-checkbox>
                            <b-button variant="primary" class="ml-2 fonte-branca ml-1" @click.prevent="adicionarValorTipoCredito">
                                <i :class="edicaoTipoCredito ? 'fa fa-pencil': 'fa fa-plus'"></i> {{ edicaoTipoCredito ?  'Editar' : 'Adicionar'}}
                            </b-button>
                        </b-form>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="d-flex justify-content-between">
                <b-col></b-col>
                <b-col>
                    <div>
                        <b-pagination v-model="configTableValorTipoCredito.currentPage" :per-page="configTableValorTipoCredito.perPage" :total-rows="configTableValorTipoCredito.rows" size="sm" class="pl-3" style="float:right" v-if="configTableValorTipoCredito.perPage != 'Todos'">
                        </b-pagination>
                        <b-form-select v-model="configTableValorTipoCredito.perPage" :options="[10, 100, 500, 1000, 'Todos']" size="sm" class="mb-3 col-3" style="float:right"></b-form-select>
                    </div>
                </b-col>
            </b-row>
            <TabelaPaginacaoFixa
                :dados="parametros.listaValorTipoCredito"
                :fields="fieldsValorTipoCredito"
                @excluir="excluirValorTipoCredito"
                @editarItem="editarTipoCredito"
                :configTable="configTableValorTipoCredito" />
            <b-row class="d-flex justify-content-between">
                <b-col></b-col>
                <b-col>
                    <div>
                        <div>
                            <b-pagination v-model="configTableValorTipoCredito.currentPage" :per-page="configTableValorTipoCredito.perPage" :total-rows="configTableValorTipoCredito.rows" size="sm" class="pl-3" style="float:right" v-if="configTableValorTipoCredito.perPage != 'Todos'">
                            </b-pagination>
                            <b-form-select v-model="configTableValorTipoCredito.perPage" :options="[10, 100, 500, 1000, 'Todos']" size="sm" class="mb-3 col-3" style="float:right"></b-form-select>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-button variant="primary" @click.prevent="salvar" :disabled="inSave">
                        <i class="fa fa-save"></i> Salvar
                    </b-button>
                    <b-button variant="primary" class="ml-2" @click="voltar">
                        <i class="fa fa-reply"></i> Voltar
                    </b-button>
                </b-col>
            </b-row>
        </b-card>
    </b-container>
</template>

<script>
import axios from 'axios'
import formatarMixins from '../../mixins/formatarMixins'
import TabelaPaginacaoFixa from './TabelaPaginacaoFixa'
import { Money } from 'v-money'

export default {
    name: 'ManterParametro',
    mixins: [ formatarMixins ],
    components: {
        TabelaPaginacaoFixa,
        Money
    },
    data() {
        return {
            money: {
                decimal: ',',
                thousands: '.',
                precision: 2,
                masked: false
            },
            inSave: false,
            edicaoTipoCredito: false,
            indexEdicaoTipoCredito: null,
            valorTipoCredito: {
                codParmVlrTpCredito: null,
                tipoCredito: null,
                valorAjuizamento: 0,
                indAtivo: true
            },
            parametros: {
                codParametro: null,
                diasFechadoFimMes: null,
                qtdSimultaneaConsultaDae: null,
                emailCoordenador: null,
                procuradorGeral: null,
                telefoneorgao: null,
                qtdThreadsObterCdas: null,
                nomeOrgao: null,
                cnpjOrgao: null,
                enderecoOrgao: null,
                municipioOrgao: null,
                qtdObterCdaPdf: null,
                tempoExecucacaoEnviarProcessoTJ: null,
                tempoExecucacaoIncluirSPJ: null,
                qtdThreadsEnviarProcessoTJ: null,
                tempoAtualizacaoPagina: null,
                qtdCdaProcesso: null,
                prazoRetornoDiaSEPA: null,
                qtdeRetornoCDAnaoDistribuidas: null,
                emailCra: null,
                qtdThreadSelecaoProtesto: null,
                dataLimiteProtesto: null,
                qtdeReferenciaQuebraXML: null,
                qtdCdaLoteCra: null,
                qtdDiasExibicaoAnuencia: null,
                qtdThreadsPagamentoParcelamentoDae: null,
                qtdThreadsConsultaPgto: null,
                listaValorTipoCredito: []
            },
            dados: {
                municipios: [],
                procuradores: [],
                tiposCredito: []
            },
            configTableValorTipoCredito: {
                perPage: 100,
                currentPage: 1,
                rows: 0,
                msgEmpty: 'Nenhum Valor/Tipo crédito encontrado.',
                modeSelect: 'single',
                selectable: true,
                limpar: false
            },
            configTableExcecoes: {
                perPage: 100,
                currentPage: 1,
                rows: 0,
                msgEmpty: 'Nenhuma Exceção encontrada.',
                modeSelect: 'single',
                selectable: true,
                limpar: false
            },
            fieldsValorTipoCredito: [
                {
                    key: 'tipoCredito.nome',
                    label: 'Tipo de Crédito',
                    sortable: true
                },
                {
                    key: 'valorAjuizamento',
                    label: 'Valor(R$)',
                    class: 'text-right',
                    thClass: 'text-center',
                    sortable: true
                },
                {
                    key: 'situacao',
                    label: 'Situação',
                    class: 'text-center',
                    sortable: true,
                    formatter: (value, key, item) => {
                        return item.indAtivo ? 'ATIVO' : 'INATIVO'
                    },
                    sortByFormatted: true,
                    filterByFormatted: true
                    
                },
                {
                    key: 'excluir',
                    label: 'Excluir',
                    class: 'text-center'
                }
            ]
        }
    },
    watch: {
        getValoresTipoCredito() {
            this.atualizarTabelas()
        }

    },
    computed: {
        getValoresTipoCredito() {
            return this.parametros.listaValorTipoCredito
        }
    },
    methods: {

        salvar() {
            this.inSave = true
            this.$validator.validateAll().then( async (result) => {
                if (!result) {
                    this.$store.commit("setMessages", { message: 'Atenção', variant: 'danger' , errors: ['Favor preencher os campos obrigatórios (*)'] });
                    this.inSave = false
                    window.scrollTo(0,0);
                    return
                }

                const urlApi = process.env.VUE_APP_ROOT_API
                const token = JSON.parse(this.$store.getters.getUser).token.access_token

                let novaLista = []
                this.parametros.listaValorTipoCredito.forEach(vtc => {
                    const { codParmVlrTpCredito, tipoCredito, valorAjuizamento, indAtivo } = vtc
                    novaLista.push({ codParmVlrTpCredito, tipoCredito, valorAjuizamento, indAtivo })
                })
                this.parametros.listaValorTipoCredito = novaLista

                const parametros = {
                    ...this.parametros
                }

                await axios.post(`${urlApi}/v1/parametros/salvar`, parametros, {
                    headers: {
                        'Authorization': token,
                        'Content-Type': 'application/json',
                    }
                })
                .then(response => {
                    if(response.data) {
                        this.$store.commit("setMessages", { message: 'Atenção', variant: 'danger' , errors: [`${response.data.message}`] });
                        window.scrollTo(0,0);
                        return
                    }
                    this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success' , errors: ['Operação realizada com sucesso!!!'] });
                    window.scrollTo(0,0)
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.inSave = false
                    this.obterParametros()
                })
            })
        },

        async adicionarValorTipoCredito() {
            const valido = this.validarParametrosValorTipoCredito(this.valorTipoCredito);
            if(!valido) {
                let msg = []
                if(!this.valorTipoCredito.tipoCredito) msg.push('O campo Tipo Crédito deve ser informado.')
                if(!this.valorTipoCredito.valorAjuizamento) msg.push('O campo Valor deve ser informado.')
                this.$store.commit("setMessages", { message: 'Atenção', variant: 'danger' , errors: msg });
                window.scrollTo(0,0);
                return
            }

            const { codParmVlrTpCredito, tipoCredito, valorAjuizamento, indAtivo } = this.valorTipoCredito
            const indexEdicao = this.indexEdicaoTipoCredito

            if(codParmVlrTpCredito) {
                if(indexEdicao >= 0) {
                    const valorTipoCreditoComValoresIguais = this.parametros.listaValorTipoCredito.filter(vtc => vtc.tipoCredito.id === tipoCredito.id)
                    if(valorTipoCreditoComValoresIguais.length) {
                        const indexNovo = this.parametros.listaValorTipoCredito.indexOf(valorTipoCreditoComValoresIguais[0])
                        if(indexNovo === indexEdicao) {
                            this.parametros.listaValorTipoCredito[indexEdicao].tipoCredito = tipoCredito
                            this.parametros.listaValorTipoCredito[indexEdicao].valorAjuizamento = valorAjuizamento
                            this.parametros.listaValorTipoCredito[indexEdicao].indAtivo = indAtivo
                        } else {
                            this.$store.commit("setMessages", { message: 'Atenção', variant: 'danger' , errors: ['Tipo de Crédito já existe.'] });
                            window.scrollTo(0,0);
                            return
                        }
                    } else {
                        this.parametros.listaValorTipoCredito[indexEdicao].tipoCredito = tipoCredito
                        this.parametros.listaValorTipoCredito[indexEdicao].valorAjuizamento = valorAjuizamento
                        this.parametros.listaValorTipoCredito[indexEdicao].indAtivo = indAtivo
                    }
                }
            } else {
                if(this.edicaoTipoCredito) {
                    if(indexEdicao >= 0) {
                        const valorTipoCreditoComValoresIguais = this.parametros.listaValorTipoCredito.filter(vtc => vtc.tipoCredito.id === tipoCredito.id)
                        if(valorTipoCreditoComValoresIguais.length) {
                            const indexNovo = this.parametros.listaValorTipoCredito.indexOf(valorTipoCreditoComValoresIguais[0])
                            if(indexNovo === indexEdicao) {
                                this.parametros.listaValorTipoCredito[indexEdicao].tipoCredito = tipoCredito
                                this.parametros.listaValorTipoCredito[indexEdicao].valorAjuizamento = valorAjuizamento
                                this.parametros.listaValorTipoCredito[indexEdicao].indAtivo = indAtivo
                            } else {
                                this.$store.commit("setMessages", { message: 'Atenção', variant: 'danger' , errors: ['Tipo de Crédito já existe.'] });
                                window.scrollTo(0,0);
                                return
                            }
                        } else {
                            this.parametros.listaValorTipoCredito[indexEdicao].tipoCredito = tipoCredito
                            this.parametros.listaValorTipoCredito[indexEdicao].valorAjuizamento = valorAjuizamento
                            this.parametros.listaValorTipoCredito[indexEdicao].indAtivo = indAtivo
                        }
                    }
                } else {
                    const valorTipoCreditoComValoresIguais = this.parametros.listaValorTipoCredito.filter(vtc => vtc.tipoCredito.id === tipoCredito.id)
                    if(!valorTipoCreditoComValoresIguais.length) {
                        this.parametros.listaValorTipoCredito.push({ tipoCredito, valorAjuizamento, indAtivo })
                    } else {
                        this.$store.commit("setMessages", { message: 'Atenção', variant: 'danger' , errors: ['Tipo de Crédito já existe.'] });
                        window.scrollTo(0,0);
                        return
                    }
                }
            }

            this.valorTipoCredito = {
                codParmVlrTpCredito: null,
                tipoCredito: null,
                valorAjuizamento: 0,
                indAtivo: true
            }
            this.configTableValorTipoCredito.limpar = true
            this.edicaoTipoCredito = false
            this.indexEdicaoTipoCredito = null
        },

        validarParametrosValorTipoCredito(valorTipoCredito) {
            let valido = true
            if(valorTipoCredito) {
                if(!valorTipoCredito.tipoCredito) valido = false
                if(!valorTipoCredito.valorAjuizamento) valido = false
            } else {
                valido = false
            }
            return valido
        },

        onlyNumber(string)
        {
            if(string) {
                var numsStr = string.toString().replace(/[^0-9]/g,'');
                return numsStr;
            }
            return null
        },

        editarTipoCredito(item) {
            if(item) {
                const index = this.parametros.listaValorTipoCredito.indexOf(item)
                this.indexEdicaoTipoCredito = index
                this.edicaoTipoCredito = true
                this.valorTipoCredito = { ...item }
            } else {
               this.valorTipoCredito = {
                    codParmVlrTpCredito: null,
                    tipoCredito: null,
                    valorAjuizamento: 0,
                    indAtivo: true
                }
                this.edicaoTipoCredito = false
                this.indexEdicaoTipoCredito = null 
            }
        },

        atualizarTabelas() {
            this.configTableValorTipoCredito.rows = this.parametros.listaValorTipoCredito.length
        },

        excluirValorTipoCredito(item) {
            if(item) {
                const index = this.parametros.listaValorTipoCredito.indexOf(item)
                this.parametros.listaValorTipoCredito.splice(index, 1)

                this.configTableValorTipoCredito.limpar = true
                this.edicaoTipoCredito = false
                this.indexEdicaoTipoCredito = null
            }
        },

        voltar() {
            this.$router.push({ path: '/' })
        },

        /**
         * Exibe erros dos catch
         */
        exibirErro(error) {
            this.$store.commit("setMessages", { message: 'Erro!', errors: [error] });
        },

        async obterParametros() {
            this.inSave = true
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).token.access_token

            axios.post(`${urlApi}/v1/parametros/obter`, {}, {
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => {
                this.parametros = response.data
                this.inSave = false
            }).catch((error) => {
                this.exibirErro(error)
            })
        },

        /**
         * Listar municípios
         */
        async listarMunicipios() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/municipio/listar`)
            .then(response => {
              this.dados.municipios = response.data
            })
        },

        /**
         * Listar procuradores
         */
        async listarProcuradores() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/parametros/listarProcurador`)
            .then(response => {
              this.dados.procuradores = response.data
            })
        },

        /**
         * Listar tipo de crédito
         */
        async listarTipoCredito() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/parametros/listarTipoCredito`)
            .then(response => {
              this.dados.tiposCredito = response.data
            })
        },

        // async obterComarca(codComarca) {
        //     const urlApi = process.env.VUE_APP_ROOT_API
        //     const token = JSON.parse(this.$store.getters.getUser).token.access_token

        //     await axios.post(`${urlApi}/v1/comarca/obter`, codComarca, {
        //         headers: {
        //             'Authorization': token,
        //             'Content-Type': 'application/json',
        //         }
        //     })
        //     .then(response => {
        //         this.comarca = response.data
        //     }).catch((error) => {
        //         this.exibirErro(error)
        //     })
        // },
    },
    mounted() {
        this.$store.commit("setMessages", {});

        this.listarMunicipios()
        this.listarProcuradores()
        this.listarTipoCredito()
        this.obterParametros()
        this.atualizarTabelas()

    }
    
}
</script>

<style scoped>

.titulo-secao {
    border-bottom: 1px solid #CECECE; 
    font-weight: bold; 
    font-style:italic;
    padding-left: 3px;
}

</style>